import React, { createRef } from 'react';
import { Button, UncontrolledCollapse } from 'reactstrap';
import { Formik, Form, Field } from 'formik';
import {Input} from '../../helpers/formik';
import { FormattedMessage } from "react-intl";

const Reply: React.FC<{ postId: string; submit: any }> = ({ postId, submit }) => {
  const replyRef = createRef<any>();
  const cancelRef = createRef<any>();
  return (
    <UncontrolledCollapse
      toggler={`reply-${postId}`}
      onEntered={() => replyRef.current.focus()}
    >
      <Formik
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          await submit({ variables: { object: values } })
          setSubmitting(false);
          resetForm();
        }}
        initialValues={{
          reply: '',
          post_id: postId
        }}
      >
        {({ isSubmitting }) => (
          <Form className="reply-form m-l-80">
            <Field
                name="reply"
                type="textarea"
                component={Input}
                innerRef={replyRef}
                placeholder="Reply"
                required
            />
            {/* <FormGroup>
              <Input
                type="textarea"
                placeholder="Reply"
                value={reply}
                onChange={e => setReply(e.target.value)} required />
            </FormGroup> */}
            <Button disabled={isSubmitting} color="primary" type="submit" size="sm"><FormattedMessage id="btn.submit" /> </Button>
            <Button size="sm" type="reset" id={`reply-${postId}`} innerRef={cancelRef}><FormattedMessage id="btn.cancel" /> </Button>
            <br /><br />
          </Form>
        )}
      </Formik>
    </UncontrolledCollapse>
  )
}

export default Reply;